module.exports = __webpack_public_path__ + "media/footer/mexico-ee830338.png";